var map = {
	"./adibauLogo.png": 6801,
	"./apk.png": 562,
	"./avi.png": 3665,
	"./folder.png": 3370,
	"./html.png": 1263,
	"./jpg.png": 6765,
	"./mp4.png": 8451,
	"./pdf.png": 5513,
	"./png.png": 5869,
	"./tif.png": 9913,
	"./txt.png": 4227,
	"./unknow.png": 547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6973;